import "features/view/components/Empty/Empty.scss";
import { ReactComponent as IconWarning } from "assets/images/icons/warning-filled.svg";
import Trans from "features/translation/components/Trans";

const Empty = ({ children }) => {
  return (
    <div className={ 'empty-container' }>
      <h3><Trans text={'Geen resultaten gevonden'} /></h3>
      <div className={ 'empty-container__message' }>
        <IconWarning/>
        { children }
      </div>
    </div>
  )
}

export default Empty;
